import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { EmailEventType } from '../../enums';
import { BigIntBaseEntity } from './base.entity';
import { EmailRecordEntity } from './email-record.entity';

@Entity('email_event', {}, { auditable: false })
@Index(['emailRecordId', 'eventType'])
@Index(['eventTimestamp'])
export class EmailEventEntity extends BigIntBaseEntity {
	@Column({ name: 'fk_email_record__id', type: 'bigint', unsigned: true })
	public emailRecordId!: string;

	@ManyToOne(() => EmailRecordEntity, (record) => record.events)
	@JoinColumn({ name: 'fk_email_record__id' })
	public emailRecord!: EmailRecordEntity;

	@Column({
		name: 'event_type',
		type: 'enum',
		enum: EmailEventType,
		enumName: 'email_event_type',
	})
	public eventType!: EmailEventType;

	@Column({ name: 'event_timestamp', type: 'timestamp' })
	public eventTimestamp!: Date;

	@Column({ name: 'ip_address', type: 'varchar', length: 45, nullable: true })
	public ipAddress?: string;

	@Column({ name: 'user_agent', type: 'text', nullable: true })
	public userAgent?: string;

	@Column({ name: 'url', type: 'text', nullable: true })
	public url?: string; // For click events

	@Column({ name: 'bounce_type', type: 'varchar', length: 50, nullable: true })
	public bounceType?: string;

	@Column({
		name: 'bounce_subtype',
		type: 'varchar',
		length: 50,
		nullable: true,
	})
	public bounceSubtype?: string;

	@Column({ name: 'raw_event_data', type: 'json', nullable: true })
	public rawEventData?: Record<string, any>;
}
